import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import ShopSideNav from "../../components/pageProps/shopPage/ShopSideNav";
import { ShopShimmerUI } from "../../components/ShimmerUI/ShimmerUI";
import { useParams, useLocation } from "react-router-dom";
import { makeRequest } from "../../makeRequest";
import { useTranslation } from "react-i18next";

const Category = () => {
  const { t } = useTranslation();

  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [priceRange, setPriceRange] = useState(null);
  const { _id } = useParams();
  const location = useLocation();
  const [categoryData, setCategoryData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Function to fetch category data
  const fetchCategoryData = async (catId) => {
    setIsLoading(true);
    try {
      const response = makeRequest.post(
        "/app/explore_category_items_list",
        JSON.stringify({ cat_id: catId })
      );

      const data = (await response).data;
      console.log(data);

      // const data = await response.json();
      if (data && data.payload) {
        setCategoryData(data.payload);
        setFilteredProducts(data.payload);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Effect to fetch data when category ID changes
  useEffect(() => {
    if (_id) {
      fetchCategoryData(_id);
      // Reset filters when category changes
      setSelectedCategories([]);
      setSelectedBrands([]);
      setPriceRange(null);
    }
  }, [_id, location.pathname]);

  // Effect to handle filtering
  useEffect(() => {
    if (categoryData) {
      let products = [...categoryData];

      // Filter by Categories
      if (selectedCategories.length > 0) {
        products = products.filter((product) =>
          selectedCategories.includes(product.category.catName)
        );
      }

      // Filter by Brands
      if (selectedBrands.length > 0) {
        products = products.filter((product) =>
          selectedBrands.includes(product.type.typeName)
        );
      }

      // Filter by Price Range
      if (priceRange) {
        products = products.filter(
          (product) =>
            product.price >= priceRange.priceOne &&
            product.price <= priceRange.priceTwo
        );
      }

      setFilteredProducts(products);
    }
  }, [categoryData, selectedCategories, selectedBrands, priceRange]);

  const handleCategoryFilter = (categories) => {
    setSelectedCategories(categories);
  };

  const handleBrandFilter = (brands) => {
    setSelectedBrands(brands);
  };

  const handlePriceFilter = (range) => {
    setPriceRange(range);
  };

  const itemsPerPageFromBanner = (itemsPerPage) => {
    setItemsPerPage(itemsPerPage);
  };

  if (isLoading) return <ShopShimmerUI />;

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title={t("home.category")} />
      <div className="w-full h-full flex pb-20 gap-10">
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav
            data={categoryData}
            onCategoryFilter={handleCategoryFilter}
            onBrandFilter={handleBrandFilter}
            onPriceFilter={handlePriceFilter}
          />
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
          {/* <ProductBanner itemsPerPageFromBanner={itemsPerPageFromBanner} /> */}

          {priceRange && filteredProducts.length === 0 ? (
            <div className="w-full text-center py-10 bg-gray-100 rounded-lg">
              <h2 className="text-2xl font-semibold text-gray-600">
                Nothing to show
              </h2>
            </div>
          ) : (
            <Pagination itemsPerPage={itemsPerPage} items={filteredProducts} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Category;
